import script from "./AppNavigationGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavigationGroup.vue?vue&type=script&setup=true&lang=js"

import "./AppNavigationGroup.vue?vue&type=style&index=0&id=447190a6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447190a6"]])

export default __exports__